import { PrimaryButton, SecondaryButton } from "../../library";
import { mobileAppHandoffCardStyles } from "./MobileAppHandoffCardStyles";

interface MobileAppHandoffCardAction {
  title: string;
  onClick: () => void;
}

interface MobileAppHandoffCardProps {
  title: string;
  description: string;
  /** "Open the app" / "Return to the app". Left out where there is nothing safe to hand over (iOS SEBIT, iOS partner). */
  primaryAction?: MobileAppHandoffCardAction;
  /** The store link. */
  secondaryAction?: MobileAppHandoffCardAction;
}

// Phone "continue in the CatchUpper app" card shown by the SSO landing screens (K12, SEBIT, external client): the
// web app is not supported on phones, so these send the learner into the mobile app or to its store page.
// Prefix: mah-.
const MobileAppHandoffCard = ({
  title,
  description,
  primaryAction,
  secondaryAction,
}: MobileAppHandoffCardProps) => (
  <div className="mah-card">
    <style>{mobileAppHandoffCardStyles}</style>
    <img className="mah-logo" src="/logos/logo-primary-2.webp" alt="CatchUpper" />
    <h1 className="mah-title">{title}</h1>
    <p className="mah-desc">{description}</p>
    <div className="mah-actions">
      {primaryAction ? (
        <PrimaryButton
          title={primaryAction.title}
          size="unlimited"
          block
          onClick={primaryAction.onClick}
        />
      ) : null}
      {secondaryAction ? (
        <SecondaryButton
          title={secondaryAction.title}
          size="unlimited"
          block
          onClick={secondaryAction.onClick}
        />
      ) : null}
    </div>
  </div>
);

export default MobileAppHandoffCard;
